
import $ from 'jquery';

var $range = $(".js-periods-string"),
    $inputFrom = $(".b-periods__period-prev"),
    $inputTo = $(".b-periods__period-next"),
    $inputFromOutside = $(".b-aside-filter__period-prev"),
    $inputToOutside = $(".b-aside-filter__period-next"),
    instance,
    min = -2000,
    max = 2000,
    from = -324,
    to = 1600;

$(function () {

    $range.ionRangeSlider({
        hide_min_max: true,
        keyboard: true,
        min: -2000,
        max: 2000,
        from: -324,
        to: 1600,
        type: 'double',
        step: 1,
        grid: true,
        onStart: updateInputs,
    	onChange: updateInputs
    });

});

function updateInputs (data) {
	from = data.from;
    to = data.to;
    
    $inputFrom.prop("value", from);
    $inputTo.prop("value", to);	
    $inputFromOutside.prop("value", from);
    $inputToOutside.prop("value", to); 
}

$inputFrom.on("input", function () {

    var instance = $range.data("ionRangeSlider");
    var val = $(this).prop("value");
    
    if (val < min) {
        val = min;
    } else if (val > to) {
        val = to;
    }
    
    instance.update({
        from: val
    });

    $inputFromOutside.prop("value", $inputFrom.val());
});

$inputTo.on("input", function () {

    var instance = $range.data("ionRangeSlider");
    var val = $(this).prop("value");
    
    if (val < from) {
        val = from;
    } else if (val > max) {
        val = max;
    }
    
    instance.update({
        to: val
    });

    $inputToOutside.prop("value", $inputTo.val());  
});


// WEBPACK FOOTER //
// ./src/js/pages/materials/periods.js